import get from 'lodash/get';
import currencies from '@/assets/locale-to-currency.json';
import { DEFAULT_CURRENCY } from '@/constants/currencies';
import i18next from './i18n';

export const locale = i18next.language;
export const language = i18next.language.substr(0, 2);
export const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const currency = get(currencies, locale, DEFAULT_CURRENCY);
